
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124.999","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2209"}},[_c('path',{attrs:{"data-name":"Rectangle 2933","fill":"none","d":"M0 0h124.999v120H0z"}}),_c('path',{attrs:{"data-name":"Path 1335","d":"M124.999 58.974L89.461 23.436c-1.252-1.645-4.044-1.425-7.294-1.425-4.418 0-8-.418-8 4.012v12.463L58.851 23.169c-1.482-1.874-4.331-1.071-7.746-.424-3.559.68-6.617.967-7.131 3.536l-2.845-2.845c-1.252-1.645-4.044-1.425-7.294-1.425-4.418 0-8-.418-8 4.012v63.976h-5.836a3.985 3.985 0 00-2.554 7.056L40.39 120h84.609z","fill":"#1c3e59"}}),_c('path',{attrs:{"data-name":"Path 1336","d":"M95.999 90h-5.832V26.024c0-4.43-3.582-4.012-8-4.012s-8-.418-8 4.012V90h-2.151L59.747 25.34c-.86-4.512-4.3-3.418-8.641-2.594s-7.938 1.067-7.086 5.571L55.739 90h-13.9V26.024c0-4.43-3.582-4.012-8-4.012s-8-.418-8 4.012V90h-5.836a4 4 0 000 8h76a4 4 0 000-8z","fill":"#4b8baf"}})])])
          )
        }
      }
    